import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import "./index.scss";
import { Link } from "react-router-dom";
import ProfileCard from "../../components/ProfileCard";
import Post from "../../components/Post";
import Cardlist from "../../components/Cardlist";
import Menu from "../../components/Menu";
import ApiContent from "../../api/ApiContent";
import ApiFollow from "../../api/ApiFollow";
import { ConvertDateShort } from "../../utils/date";
import { WEB_IMAGE } from "../../env";
import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import MainPost from "../../components/PostV2";
import InfiniteScroll from "react-infinite-scroll-component";
import MenuDrawer from "../../components/MenuDrawer";
import Drawer from "rc-drawer";
import ApiTranProfile from "../../api/ApiTranProfile";
import CSwl from "../../utils/alert";
import ProfileCardSearch from "../../components/ProfileCardSearch";
import { useTranslation } from "react-i18next";
import { destroyPage, useWindowUnloadEffect } from "../../utils";
import PostLiveSharing from "../../components/PostLiveSharing";
const initialState = {
    pageNumber: 1,
    pageSize: 10,
};

const SearchPage = (props) => {
    const [firstTime, setFirstTime] = useState(new Date());
    const [searchType, setsearchType] = useState('CONTENT');
    useWindowUnloadEffect(() => destroyPage({ page: "Search", firstTime: firstTime }), true);
    const { t, i18n } = useTranslation();
    const [search, setSearch] = useState(new URLSearchParams(props.location.search).get("q"));
    const [state, setstate] = useState(initialState);
    const [contents, setcontents] = useState("");
    const [profiles, setprofiles] = useState("");
    const userState = useSelector((state) => state.user);
    const history = useHistory();
    const [enterSearch, setenterSearch] = useState('');
    const [loadingMore, setloadingMore] = useState(false);
    useEffect(() => {
        setstate(initialState);
        // const promise1 = getContentBysearch();
        const promise2 = getProfileBySearch();
        // CSwl.SwalLoad();
        Promise.all([promise2]).then(result => {
            // CSwl.SwalClose();
        })
        return () => { };
    }, [search]);

    // useEffect(() => {
    //     if (enterSearch.length > 0) {
    //         getContentBysearch();
    //     }
    //     return () => {
    //     }
    // }, [enterSearch])

    useEffect(() => {
        setSearch(new URLSearchParams(props.location.search).get("q"));
        return () => { };
    }, [props.location]);

    useEffect(() => {
        const promise1 = getContentBysearch();
        CSwl.SwalLoad();
        Promise.all([promise1]).then(result => {
            CSwl.SwalClose();
        })
        return () => { };
    }, [searchType]);


    const getContentBysearch = async () => {
        const result = await ApiContent.getBySearch({ ...initialState, search: search, searchType: searchType });
        if (result.status == 200) {
            setcontents(result.data.data);
        }
    };

    const getProfileBySearch = async () => {
        const result = await ApiTranProfile.GetProfileBySearch({ ...initialState, search: search });
        if (result.status == 200) {
            setprofiles(result.data.data);
        }
    };


    const callBackComment = (result) => {
        try {
            const comment = result.data;
            console.log('comment::', comment)
            // const { data } = result;
            let newContents = { ...contents };
            let newContentsItem = newContents.items;

            const findIndex = newContentsItem.findIndex(x => x.id == comment.ctid);
            newContentsItem[findIndex].comments.unshift(comment);
            newContents.items = newContentsItem;
            setcontents(newContents);
        } catch (error) {
            console.log(error);
        }
    }

    const searchPost = () => {
        history.push(`/search?q=${search}`)
        setenterSearch(search);
    }

    function handleLoadMore() {
        if (loadingMore == false) {
            setloadingMore(true);
            setstate({ ...state, pageNumber: state.pageNumber + 1 })
        }
    }

    useEffect(() => {
        if (state.pageNumber != 1) {
            const promise1 = getContentLoadmore();
            Promise.all([promise1]).then(results => {
                setloadingMore(false);
            })
        }
        return () => {
        }
    }, [state])

    const getContentLoadmore = async () => {
        const result = await ApiContent.getBySearch({ ...state, search: search, searchType: searchType });
        if (result.status == 200) {
            setcontents({
                ...contents,
                items: [...contents.items, ...result.data.data.items]
            });
            console.log("loadmore::", result.data.data.items)
        }
    };



    return (
        <div id="search-page">
            <Drawer className="is-hidden-desktop is-hidden-tablet">
                <MenuDrawer data={[]} page="rank" header={t('menu.search')} />
            </Drawer>
            <Header />
            <div className="columns">
                <div className="column is-hidden-mobile  is-2 layer">
                    <Menu data={[]} page="rank" header={t('menu.search')} />
                </div>
                <div className="column middle-container is-9 layer2 mt-0">
                    <div className="flex justify-between">
                        <h2 className="fontH mb-2">{`${search ?? "ทั้งหมด"}`}</h2>
                        <div className="flex gap-2 mt-4 mb-4 items-center">
                            <div>Filter : </div>
                            <div className="flex gap-2">
                                {/* <div onClick={() => {
                                    setsearchType("CONTENT")
                                }} className="cursor-pointer  flex gap-2 items-center">
                                    <img
                                        src={process.env.PUBLIC_URL + "/images/content/full_coverage.png"}
                                        alt="Icon"
                                        className='w-5 h-5'
                                    />
                                    <div className={`${searchType == "CONTENT" && "text-[#f97316] font-bold underline orange-underline"}`}>
                                        Knowledge
                                    </div>
                                </div> */}
                                <div onClick={() => {
                                    setsearchType("CONTENT")
                                }} >
                                    <Badge label="Knowledge" active={searchType == "CONTENT"} type="knowledge" />
                                </div>

                                <div onClick={() => {
                                    setsearchType("LEARNING_PATH")
                                }} >
                                    <Badge label="Knowledge Path" active={searchType == "LEARNING_PATH"} type="knowledgePath" />
                                </div>
                                {/* <div className="text-[#cfcfcf]"> | </div> */}

                                {/* <div onClick={() => {
                                    setsearchType("LEARNING_PATH")
                                }} className="cursor-pointer  flex gap-2 items-center">
                                    <img
                                        src={process.env.PUBLIC_URL + "/images/content/conversion_path.png"}
                                        alt="Icon"
                                        className='w-5 h-5'
                                    />
                                    <div className={`${searchType == "LEARNING_PATH" && "text-[#f97316] font-bold underline orange-underline"}`}>
                                        Learning Path
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* section menu */}
                    {/* <div className="column is-2 layer my-3">
                    <Menu data={dataPro} page="first" />
                </div> */}
                    {/* section post */}
                    <div className="column">
                        <h2 className="text-lg mb-2">{`People ${`(${(profiles && profiles?.items.length) ?? 0})`}`}</h2>
                        <div className="ar" style={{ marginBottom: 15 }}></div>
                        {/* <div className="d-flex" style={{ maxWidth: '100%', overflow: 'auto', padding: !(profiles && profiles.items.length == 0) ? '20px 20px' : '0px' }}>

                        </div> */}
                        <div className="flex overflow-auto gap-2 mb-4">

                            <div className="flex-1">
                                {/* <div
                                    // to="/"
                                    className="has-text mr-6 is-flex is-align-items-center"
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/images/firstPage/fi-rr-portrait1.png"
                                        }
                                        alt="logo1"
                                        width="24"
                                        height="24"
                                    />
                                    <strong className="m-3">{t('text.who_smes')}</strong>
                                </div> */}
                                <div className="flex overflow-auto gap-2">
                                    {profiles && profiles.items.map((d, index) => {
                                        let tagsArray = [];
                                        let smeCategoryArray = [];
                                        let specialistArray = [];
                                        if (d.tagJson && d.tagJson != "[]") {
                                            let tags = JSON.parse(d.tagJson);
                                            tagsArray = tags.map(x => x.Name);
                                        }
                                        if (d.smeCategory && d.smeCategory != "[]") {

                                            let smes = d.smeCategory.split(',');
                                            smeCategoryArray = smes;
                                        }
                                        if (d.specialistJson && d.specialistJson != "[]") {
                                            let tags = JSON.parse(d.specialistJson);
                                            specialistArray = tags.map(x => x.name);
                                        }
                                        return (
                                            <div className="column size-procard" key={index}>
                                                <ProfileCard
                                                    image={
                                                        d.image
                                                            ? process.env.REACT_APP_IMAGE + d.image
                                                            : process.env.PUBLIC_URL +
                                                            "/images/profilePage/Profile.png"
                                                    }
                                                    profile={d}
                                                    profileid={d.id}
                                                    name={d.firstNameEnglish + " " + d.lastNameEnglish}
                                                    depart={d.dept}
                                                    level={d.rankEng}
                                                    totalArticle={d.articleAmt}
                                                    totalFollow={d.followerAmt}
                                                    isFollow={d.isFollow}
                                                />
                                            </div>
                                            // <ProfileCardSearch
                                            //     profile={d}
                                            //     key={d.id}
                                            //     profileid={d.id}
                                            //     tagsArray={tagsArray}
                                            //     specialistArray={specialistArray}
                                            //     depart={d.dept}
                                            //     totalArticle={d.articleAmt}
                                            //     totalFollow={d.followerAmt}
                                            //     isFollow={d.isFollow}
                                            //     image={d.image
                                            //         ? process.env.REACT_APP_IMAGE + d.image
                                            //         : process.env.PUBLIC_URL +
                                            //         "/images/profilePage/Profile.png"}
                                            //     name={d.firstNameEnglish + " " + d.lastNameEnglish}
                                            //     email={d.email}
                                            //     smeCategory={d.smeCategory ? d.smeCategory.split(',') : []}
                                            // />
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="flex-1">
                                {/* <div
                                    // to="/"
                                    className="has-text mr-6 is-flex is-align-items-center"
                                >
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/images/firstPage/fi-rr-portrait1.png"
                                        }
                                        alt="logo1"
                                        width="24"
                                        height="24"
                                    />
                                    <strong className="m-3">{t('text.who_follow')}</strong>
                                </div> */}
                                {/* <div className="flex overflow-auto gap-2">

                                    {profiles && profiles.items.filter(x => !x.smeCategory).map((d, index) => {
                                        let tagsArray = [];
                                        let smeCategoryArray = [];
                                        let specialistArray = [];
                                        if (d.tagJson && d.tagJson != "[]") {
                                            let tags = JSON.parse(d.tagJson);
                                            tagsArray = tags.map(x => x.Name);
                                        }
                                        if (d.smeCategory && d.smeCategory != "[]") {

                                            let smes = d.smeCategory.split(',');
                                            smeCategoryArray = smes;
                                        }
                                        if (d.specialistJson && d.specialistJson != "[]") {
                                            let tags = JSON.parse(d.specialistJson);
                                            specialistArray = tags.map(x => x.name);
                                        }
                                        return (
                                            <ProfileCardSearch
                                                key={d.id}
                                                profileid={d.id}
                                                tagsArray={tagsArray}
                                                specialistArray={specialistArray}
                                                depart={d.dept}
                                                totalArticle={d.articleAmt}
                                                totalFollow={d.followerAmt}
                                                isFollow={d.isFollow}
                                                image={d.image
                                                    ? process.env.REACT_APP_IMAGE + d.image
                                                    : process.env.PUBLIC_URL +
                                                    "/images/profilePage/Profile.png"}
                                                name={d.firstNameEnglish + " " + d.lastNameEnglish}
                                                email={d.email}
                                                smeCategory={d.smeCategory ? d.smeCategory.split(',') : []}
                                            />
                                        );
                                    })}
                                </div> */}
                            </div>
                        </div>
                        {/* <h2 className="fontH mb-2">{`${"บทความ"} ${`(${contents.totalItems ?? 0})`}`}</h2> */}
                        <h2 className="text-lg mb-2">{`บทความ ${`(${contents.totalItems ?? 0})`}`}</h2>
                        {!(profiles && profiles.items.length == 0) && <div className="mb-5"></div>}


                        <div className="ar" style={{ marginBottom: 15 }}></div>
                        {contents &&
                            <InfiniteScroll
                                dataLength={contents.items.length}
                                next={() => handleLoadMore()}
                                hasMore={contents.totalPages > state.pageNumber}
                                loader={<h4>Loading...</h4>}
                            >
                                {contents &&
                                    contents.items.map((d, index) => {
                                        return (
                                            <div className="row fn ar" key={d.id}>
                                                {
                                                    d.cttype != "LIVESHARING" ? <MainPost
                                                        time={ConvertDateShort(d.cttrandate, "DD MMM YYYY HH:mm น.")}
                                                        totalLike={d.ctlikeAmt}
                                                        isLike={d.isLike}
                                                        isBookmark={d.isBookmark}
                                                        item={d}
                                                        title={d.ctname}
                                                        comments={d.comments}
                                                        detail={d.ctdeschtml}
                                                        name={`${d.employee?.firstNameEnglish} ${d.employee?.lastNameEnglish}`}
                                                        image={
                                                            d.imageProfile
                                                                ? process.env.REACT_APP_IMAGE + d.imageProfile
                                                                : process.env.PUBLIC_URL +
                                                                "/images/profilePage/Profile.png"
                                                        }
                                                    />
                                                        : <PostLiveSharing
                                                            stateOrg={[]}
                                                            time={ConvertDateShort(d.ctstartdate, "DD MMM YYYY HH:mm น.")}
                                                            totalLike={d.ctlikeAmt}
                                                            isLike={d.isLike}
                                                            isBookmark={d.isBookmark}
                                                            item={d}
                                                            title={d.ctname + " (LIVE SHARING)"}
                                                            comments={d.comments}
                                                            detail={d.ctdeschtml}
                                                            name={`${d.employee?.firstNameEnglish} ${d.employee?.lastNameEnglish}`}
                                                            image={
                                                                d.imageProfile
                                                                    ? process.env.REACT_APP_IMAGE + d.imageProfile
                                                                    : process.env.PUBLIC_URL +
                                                                    "/images/profilePage/Profile.png"
                                                            }
                                                        />
                                                }
                                            </div>
                                        );
                                    })}
                            </InfiniteScroll>
                        }
                        {contents && contents.items == 0 && (
                            <div className="m-5">ไม่พบบทความ</div>
                        )}
                    </div>

                </div>
                {(enterSearch && contents.items == 0) &&
                    <div className="m-5">ไม่พบบทความ</div>
                }

            </div>

        </div>
    );
};

function Badge({ label, type, active }) {
    const badgeStyles = {
        verified: 'bg-green-500 text-white px-4 py-1.5 rounded-full flex items-center gap-2 shadow-md' + `${active == true ? "" : " opacity-20"}`,
        knowledgePath: 'bg-orange-500 text-white px-4 py-1.5 rounded-full flex items-center gap-2 shadow-md cursor-pointer' + `${active  == true? "" : " opacity-20"}`,
        knowledge: 'bg-blue-600 text-white px-4 py-1.5 rounded-full flex items-center gap-2 shadow-md cursor-pointer' + `${active  == true? "" : " opacity-20"}`,
    };

    const icon = {
        verified: (
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="24" height="24">
                <circle cx="12" cy="12" r="10" fill="white" />
                <path d="M9.75 12.75l1.5 1.5 4.5-4.5" stroke="green" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        ),
        knowledgePath: (
            <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_1072_91"  maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1072_91)">
                    <path d="M12.6654 14C12.232 14 11.8431 13.875 11.4987 13.625C11.1543 13.375 10.9154 13.0556 10.782 12.6667H7.33203C6.5987 12.6667 5.97092 12.4056 5.4487 11.8833C4.92648 11.3611 4.66536 10.7333 4.66536 10C4.66536 9.26667 4.92648 8.63889 5.4487 8.11667C5.97092 7.59444 6.5987 7.33333 7.33203 7.33333H8.66536C9.03203 7.33333 9.34592 7.20278 9.60703 6.94167C9.86814 6.68056 9.9987 6.36667 9.9987 6C9.9987 5.63333 9.86814 5.31944 9.60703 5.05833C9.34592 4.79722 9.03203 4.66667 8.66536 4.66667H5.21536C5.07092 5.05556 4.82925 5.375 4.49036 5.625C4.15148 5.875 3.76536 6 3.33203 6C2.77648 6 2.30425 5.80556 1.91536 5.41667C1.52648 5.02778 1.33203 4.55556 1.33203 4C1.33203 3.44444 1.52648 2.97222 1.91536 2.58333C2.30425 2.19444 2.77648 2 3.33203 2C3.76536 2 4.15148 2.125 4.49036 2.375C4.82925 2.625 5.07092 2.94444 5.21536 3.33333H8.66536C9.3987 3.33333 10.0265 3.59444 10.5487 4.11667C11.0709 4.63889 11.332 5.26667 11.332 6C11.332 6.73333 11.0709 7.36111 10.5487 7.88333C10.0265 8.40556 9.3987 8.66667 8.66536 8.66667H7.33203C6.96536 8.66667 6.65148 8.79722 6.39036 9.05833C6.12925 9.31945 5.9987 9.63333 5.9987 10C5.9987 10.3667 6.12925 10.6806 6.39036 10.9417C6.65148 11.2028 6.96536 11.3333 7.33203 11.3333H10.782C10.9265 10.9444 11.1681 10.625 11.507 10.375C11.8459 10.125 12.232 10 12.6654 10C13.2209 10 13.6931 10.1944 14.082 10.5833C14.4709 10.9722 14.6654 11.4444 14.6654 12C14.6654 12.5556 14.4709 13.0278 14.082 13.4167C13.6931 13.8056 13.2209 14 12.6654 14ZM3.33203 4.66667C3.52092 4.66667 3.67925 4.60278 3.80703 4.475C3.93481 4.34722 3.9987 4.18889 3.9987 4C3.9987 3.81111 3.93481 3.65278 3.80703 3.525C3.67925 3.39722 3.52092 3.33333 3.33203 3.33333C3.14314 3.33333 2.98481 3.39722 2.85703 3.525C2.72925 3.65278 2.66536 3.81111 2.66536 4C2.66536 4.18889 2.72925 4.34722 2.85703 4.475C2.98481 4.60278 3.14314 4.66667 3.33203 4.66667Z" fill="white" />
                </g>
            </svg>
        ),
        knowledge: (
            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="24" height="24">
                <rect x="6" y="5" width="12" height="14" rx="2" ry="2" stroke="white" strokeWidth="2" fill="none" />
                <path d="M9 8h6m-6 4h4" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
        ),
    };

    return (
        <div className={badgeStyles[type]}>
            {icon[type]}
            <span className="font-medium">{label}</span>
        </div>
    );
}

export default SearchPage;
